<div
  class="select-field"
  [ngClass]="{
    'has-value': !!fieldControl?.value,
    'has-placeholder': !!placeholder,
    'has-column-layout': layoutDirection !== 'row'
  }"
>
  <label
    [attr.data-tooltip-id]="labelTooltip?.selectors"
    class="input-label field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: disabled || fieldControl?.disabled
    }"
    [attr.for]="fieldId"
    (click)="labelIcon && labelTooltip && showInfoTooltip($event)"
  >
    {{ label }}

    <i2g-icon *ngIf="labelIcon" class="label-icon" [icon]="labelIcon">
    </i2g-icon>
  </label>

  <div
    class="select-wrapper"
    [ngClass]="{ 'has-left-icon': !!leftIcon, 'is-open': isOpen }"
  >
    <i2g-icon *ngIf="leftIcon" class="icon" [icon]="leftIcon"> </i2g-icon>

    <input
      #input
      class="input"
      autocomplete="off"
      i2gInput
      [valueAlignment]="valueAlignment"
      tabindex="0"
      [i2gFocusable]="focusableTrigger$"
      [attr.id]="fieldId"
      [attr.placeholder]="placeholder"
      [attr.maxlength]="maxlength <= 0 ? null : maxlength"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      [formControl]="selectFieldControl"
      [attr.data-e2e-id]="e2eId"
      [attr.disabled]="disabled || fieldControl?.disabled || null"
      i2gTrackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
      (blur)="onBlur()"
      (focus)="onFocus()"
      (keyup)="inputKeyup.emit($event)"
      (keydown)="onKeyDown($event)"
      (click)="onClick()"
      (input)="onInputChange($event.target.value)"
    />

    <i2g-icon class="select-arrow" name="chevron-down" size="small"></i2g-icon>

    <ul class="options" *ngIf="isOpen" (mousemove)="onMouseMove($event)">
      <li
        #option
        class="option"
        *ngFor="let item of filteredOptions; let i = index"
        (mousedown)="pickItem(i)"
        (mouseenter)="hoverItem($event, i)"
        [class.selected]="i === selectionIndex"
      >
        <div class="content">{{ item.key }}</div>
      </li>
    </ul>

    <i2g-error-message
      class="error"
      [dirty]="fieldControl.dirty"
      [invalid]="fieldControl.invalid"
      [errorMessage]="errorMessage"
    >
    </i2g-error-message>

    <p *ngIf="description" class="description">
      {{ description }}
    </p>
  </div>
</div>
